<template>
  <div class="">
    <div class="filter">
      <div class="flex " style="align-items: flex-start;"><span>所属地区</span>
        <div class="list ">
          <div v-for="(item1,index) in data[0].list">
            <span @click="selectAll(item1)" :class="item1.checked==true?'active':''">{{item1.label}} <i
                class="el-icon-arrow-right"></i></span>
            <span @click="check_diqu(item)" :class="item.checked==true?'active':''"
              v-for="(item,index1) in item1.list">{{item.label}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="filter" v-for="(item0,index0) in data1">
      <div class="flex " style="align-items: flex-start;"><span>{{item0.name}}<i class="el-icon-arrow-right"></i></span>
        <div class="list flex">
          <span @click="check(item,index0)" :class="item.checked==true?'active':''"
            v-for="(item,index) in item0.list">{{item.label}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        data: [],
        data1: [],
        conditions: {
          province_id: [],
          type: [],
          category_id: [],
          levels: []
        }
      }
    },
    created() {
      this.$http.getList().then(res => {
        this.data = res.data
        this.data1 = res.data.slice(1)
        console.log(this.data1)
      })
      setTimeout(() => {
        console.log(this.data[0][0])
      }, 1000)
    },
    methods: {
      selectAll(item1) {
        if (item1.checked == true) {
          item1.checked = false
          item1.list.forEach(item2 => {
            item2.checked = false
            this.conditions.province_id.splice(this.conditions.province_id.indexOf(item2.value), 1)
          })
          console.log(this.conditions.province_id)
          this.$emit('clickAll', this.conditions)
        } else {
          item1.checked = !item1.checked
          this.$forceUpdate()
          console.log(item1)
          item1.list.forEach(item2 => {
            item2.checked = !item2.checked
            this.conditions.province_id.push(item2.value)
          })
          console.log([...new Set(this.conditions.province_id)])
          this.$emit('clickAll', this.conditions)
        }

      },
      /* 选择地区 */
      check_diqu(item) {
        item.checked = !item.checked
        let arrIndex = this.conditions.province_id.indexOf(item.value);
        if (arrIndex > -1) {
          this.conditions.province_id.splice(arrIndex, 1);
        } else {
          this.conditions.province_id.push(item.value)
        }
        console.log(arrIndex)
        this.$emit('clickone', this.conditions)
      },
      /* 选择其他选项*/
      check(item, index) {
        console.log(item, index)
        item.checked = !item.checked
        if (index == 0) {
          if (this.conditions.type.indexOf(item.value) > -1) {
            this.conditions.type.splice(this.conditions.type.indexOf(item.value), 1)
          } else {
            this.conditions.type.push(item.value)
          }
        }
        if (index == 1) {
          if (this.conditions.category_id.indexOf(item.value) > -1) {
            this.conditions.category_id.splice(this.conditions.category_id.indexOf(item.value), 1)
          } else {
            this.conditions.category_id.push(item.value)
          }
        }
        if (index == 2) {
          if (item.label == '双一流') {
            if (this.conditions.levels.indexOf((item.value)) > -1) {
              this.conditions.levels.splice(this.conditions.levels.indexOf((item.value)), 1)
            } else {
              this.conditions.levels.push((item.value))
            }
          } else {
            if (this.conditions.levels.indexOf(Number(item.value)) > -1) {
              this.conditions.levels.splice(this.conditions.levels.indexOf(Number(item.value)), 1)
            } else {
              this.conditions.levels.push(Number(item.value))
            }
          }

        }
        this.$forceUpdate()
        this.$emit('clickone', this.conditions)
        console.log(this.conditions)
      }
    }
  }
</script>

<style scoped lang="scss">
  .schoolList {
    margin: 40px 0;
  }

  .list {
    margin-left: 40px;
    width: 800px;
    text-align: left;

    &>div {
      margin-bottom: 23px;
    }

    /* justify-content: space-between; */
  }

  .list span {
    margin: 0px 26px 28px 0px;
    cursor: pointer;
  }

  .active {
    color: #19CACA;
  }
</style>



// WEBPACK FOOTER //
// src/components/filter.vue